import { defaultTranslations } from '../default/settings';

export type Translations = typeof defaultTranslations;